import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { IKanbanBoardRecord, IKanbanItemRecord } from "../../../lib/types";
import Container from "../../../components/Container";
import pb from "../../../lib/pocketbase";
import BoardType from "../../../components/studio/kanban/BoardType";
import EditableField from "../../../components/form/EditableField";

export default function KanbanBoard() {
    const id = useParams().id;
    const [board, setBoard] = useState<IKanbanBoardRecord>();
    const [title, setTitle] = useState("");

    const [isLoading, setIsLoading] = useState(true);

    async function load() {
        if (!id) return;
        const kanbanBoard: IKanbanBoardRecord = await pb.collection("kanbanBoard").getOne(id, {
            expand: "kanbanType(board),kanbanItem(board)"
        });
        console.log(kanbanBoard);
        setTitle(kanbanBoard.title);
        setBoard(kanbanBoard);

        setIsLoading(false);
    }

    useEffect(() => {
        load();
    }, []);

    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Board — {board?.title || ""}</title>
            </Helmet>
            <Container variant={"extra-large"} className="my-8">
                <h2 className="mb-8 text-3xl font-bold">
                    <EditableField value={title} onChange={setTitle} />
                </h2>
                <div className="scrollbar flex w-full gap-4 overflow-x-scroll py-2">
                    {board?.expand["kanbanType(board)"]?.map((type) => {
                        return <BoardType type={type} items={board.expand["kanbanItem(board)"]} />;
                    })}
                </div>
            </Container>
        </>
    );
}
